import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, NgForm } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { GoogleAnalyticsService } from '../DataLayer/google-analytics-service.service';
import { getParamsType } from '../model/getParamsType';
import { LeadTypeClass } from '../model/LeadType';
import { AdobeDTM } from '../services/adobe-dtm.service';
import { FormControlsAndLogicsService } from '../services/form-controls-and-logics-service.service';
import { SharedService } from '../services/shared.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-review-details',
    templateUrl: './review-details.component.html',
    styleUrls: ['./review-details.component.scss'],
    standalone: false
})
export class ReviewDetailsComponent implements OnInit,AfterViewInit {
  isOn: boolean = true;
  leadId:any;

  clinicsList = ([] as any[]);
  servicesListForLead : Array<string> = [];

  action:any
  clinicId:any
  
firstName:any
lastName:any
jobtitle:any
emailaddress1:any
mobilephone:any

companyname:any
aci_companysize:any


aci_billyourparticipantsinsurers =false
aci_employeesofthe=false
aci_employeesoftheValue="Yes"
aci_responsibleforreimbursementtothepharmacyValue="Your organization";
aciInsuranceName=false
aci_responsibleforreimbursementtothepharmacy=false
aci_collectpaymentfromparticipants=false
aci_billyourcompanydirectly=false
aci_split_costwithparticipants=false

covid19 =false;
flu=false;
shingrix=false;
tdap=false;
pneumonia=false;
covid19testing=false;
a1ctesting=false;
cholestrol=false;
bloodglucose=false;
clinicType="On-site at your location";


aci_ismultidayclinic=false;
aci_isthereaspecificdateyoudliketohold=false;
aci_isthereaspecificdate: any;
aci_proposedtimeofdays="Morning";
aci_clinicName:any;
aci_cliniccontactname:any;
aci_onsitecontactlastname : any;
aci_cliniccontactphonenumber="12345";
aci_streetaddress="test test";
aci_monday=false;
aci_tuesday=false;
aci_wednesday=false;
aci_thursday=false;
aci_friday=false;
aci_saturday=false;
aci_sunday=false;
travelhealth=false;
Hepatitis=false;
reviewSubmittext: any ="Review and submit";
previuosButtonTabIndex: any = -1;
            

  constructor(
    private router: Router, private route:ActivatedRoute,
    public sharedService: SharedService,
    private renderer: Renderer2,
    public datepipe: DatePipe, 
    private formBuilder: FormBuilder,
    private leadTypeClass: LeadTypeClass,
    private adobeDTM: AdobeDTM,
    private fornControlsObj: FormControlsAndLogicsService,
    protected $gaService: GoogleAnalyticsService,
    private el:ElementRef) {

      
     }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params:ParamMap)=>{
      this.leadId=params.get('id');
      this.action=params.get('action');
      this.clinicId=params.get('gid');

   
    
      
      if(this.action=='CE'||this.action=='RE'){
        this.isOn=false;
        this.getLeadDetails();
        var res = this.clinicsList.filter((data) => data.aci_clinicid == this.clinicId);
        this.BindData(res);
        this.isOn=false;
        this.reviewSubmittext="Clinic details";
      }
       else if(this.leadId){
        this.isOn=true;
        this.getLeadDetails();
      
       }

      
       
    })
  }

  ngAfterViewInit(): void {

  }

  onClinicDetailsFormSubmit(form: NgForm) {

    this.router.navigate(['/clinic-submitted',{id:this.leadId}]);

  }

  onPreviousClick() {

    this.router.navigate(['/billing',{id:this.leadId}]);
  }



  
  clinicDetails(value:string,response:any) {

    if(value=='edit'){
      this.BindData(response);
      this.isOn=false;
      this.clinicId=response.aci_clinicid;
      this.reviewSubmittext="Clinic details";
    }
    else if(value=='back' && this.action=='CE'){
      this.router.navigate(['/clinic-details',{id:this.leadId,action:'back'}]);
     
    }else{
      this.isOn = !this.isOn;
      this.reviewSubmittext="Review and submit";
    }  
   
 
  }

  editDetails(param: string) {
    if(!this.action){this.action='RE'};
    this.router.navigate(['/'+param,{id:this.leadId,action:this.action,gid:this.clinicId}]);
  }


  
  getLeadDetails() {
    const url: string = `groupclinic/getClinicByLeadId`;
    const getParams: getParamsType = {
      entityName: 'aci_clinic',
      entityId: this.leadId,
      columns:
        'aci_clinicid,aci_clinictype,aci_immunizationtype,aci_clinicservicetype,aci_ismultidayclinic,aci_isthereaspecificdate,aci_proposedtimeofdays,aci_clinicname,aci_cliniccontactname,aci_onsitecontactlastname,aci_cliniccontactphonenumber,aci_streetaddress,aci_monday,aci_tuesday,aci_wednesday,aci_thursday,aci_friday,aci_saturday,aci_sunday,aci_isthereaspecificdateyoudliketohold,aci_estimateofdoses,aci_clinicnoteimportantinformation',
    };
    this.sharedService.postRequest(url, getParams).subscribe({
     next: (response) => {
        if (response != null) {
          this.clinicsList = response.value;
          this.bindClinicDataByLead(this.clinicsList);
        if(this.isOn){
         return
             }
        }
      },
     error: (errorResponse) => {
        console.log(errorResponse);
      }
    }
    );
  }

  bindClinicDataByLead(response:any){
    this.clinicsList.forEach(element => {
      element.aci_isthereaspecificdate = element.aci_isthereaspecificdateyoudliketohold ? this.datepipe.transform(element.aci_isthereaspecificdate, 'MM/dd/YYYY') : 'NO';
    });
  }


  BindData(response:any){

    const url: string = `groupclinic/getClinicLead`;
    const getParams: getParamsType = {
      entityName: 'lead',
      entityId: this.leadId,
      columns:
        '_aci_state_value,address1_city,address1_postalcode,aci_leadtype,address1_stateorprovince,_aci_division_value,companyname,_aci_zipcode_value,emailaddress1,lastname,mobilephone,firstname,telephone1,aci_billyourcompanydirectly,aci_collectpaymentfromparticipants,aci_employeesofthe,aci_insurancename,aci_companysize,aci_responsibleforreimbursementtothepharmacy,aci_billyourparticipantsinsurers,aci_split_costwithparticipants,jobtitle',
    };
    this.sharedService.postRequest(url, getParams).subscribe({
     next: (response) => {
        if (response != null) {
this.firstName = response.firstname
this.lastName = response.lastname
this.jobtitle =response.jobtitle
this.emailaddress1 =response.emailaddress1
this.mobilephone =response.mobilephone

this.companyname=response.companyname
if(response.aci_companysize == '100')
{
  this.aci_companysize= '1 - 100' ;
}
if(response.aci_companysize == '250')
{
  this.aci_companysize= '101 - 250';
}
if(response.aci_companysize == '500')
{
  this.aci_companysize= '251 - 500';
}
if(response.aci_companysize == '2000')
{
  this.aci_companysize= '500 +';
}


if(response.aci_billyourparticipantsinsurers){
this.aci_billyourparticipantsinsurers=true;
}
if(response.aci_employeesofthe){
this.aci_employeesofthe=true;
if(response.aci_employeesofthe=="805170000"){
  this.aci_employeesoftheValue="Yes"
}
else{
  this.aci_employeesoftheValue="No"
}

}
if(response.aciInsuranceName){
  this.aciInsuranceName=true;
  }
  if(response.aci_responsibleforreimbursementtothepharmacy){
    this.aci_responsibleforreimbursementtothepharmacy=true;
    if(response.aci_responsibleforreimbursementtothepharmacy=="805170000"){
      this.aci_responsibleforreimbursementtothepharmacyValue="Your organization"
    }else{
      this.aci_responsibleforreimbursementtothepharmacyValue="Participants"
    }
    }
    if(response.aci_collectpaymentfromparticipants){
      this.aci_collectpaymentfromparticipants=true;
      }
      if(response.aci_billyourcompanydirectly){
        this.aci_billyourcompanydirectly=true;
        }
        if(response.aci_split_costwithparticipants){
this.aci_split_costwithparticipants=true;
}

        }
      },
     error: (errorResponse) => {
      
        console.log(errorResponse);
      }
    }
    );

const urlClinic: string =  `groupclinic/getClinic`;
const getParams12: getParamsType = {
  entityName: 'aci_clinic',
  entityId: response.aci_clinicid?response.aci_clinicid:this.clinicId,
  columns:
    'aci_clinictype,aci_immunizationtype,aci_clinicservicetype,aci_ismultidayclinic,aci_isthereaspecificdate,aci_proposedtimeofdays,aci_clinicname,aci_cliniccontactname,aci_onsitecontactlastname,aci_cliniccontactphonenumber,aci_streetaddress,aci_monday,aci_tuesday,aci_wednesday,aci_thursday,aci_friday,aci_saturday,aci_sunday',
};
this.sharedService.postRequest(urlClinic, getParams12).subscribe({
  next: (response) => {

    if(response.aci_clinictype){
      this.clinicType=(response.aci_clinictype == '805170000')
      ? 'On-site at your location'
      : 'Voucher program at our pharmacies';
    }
    if(response.aci_proposedtimeofdays){
      if(response.aci_proposedtimeofdays=="805170000"){
this.aci_proposedtimeofdays="Morning";
      }
      else if (response.aci_proposedtimeofdays=="805170001"){
        this.aci_proposedtimeofdays="Afternoon";
      }
      else if(response.aci_proposedtimeofdays=="805170002"){
        this.aci_proposedtimeofdays="Evening";
      } 
      else{
        this.aci_proposedtimeofdays="Flexible";
      } 

    }
    if(response.aci_cliniccontactphonenumber)  {
      this.aci_clinicName=response.aci_clinicname?response.aci_clinicname : '';
      this.aci_cliniccontactname= response.aci_cliniccontactname ? response.aci_cliniccontactname : '';
      this.aci_onsitecontactlastname=response.aci_onsitecontactlastname ?response.aci_onsitecontactlastname : '';
      this.aci_cliniccontactphonenumber=response.aci_cliniccontactphonenumber
      this.aci_streetaddress=response.aci_streetaddress;
      this.aci_monday=response.aci_monday;
      this.aci_tuesday=response.aci_tuesday;
      this.aci_wednesday=response.aci_wednesday;
      this.aci_thursday=response.aci_thursday;
      this.aci_friday=response.aci_friday;
      this.aci_saturday=response.aci_saturday;
      this.aci_sunday=response.aci_sunday;
      this.aci_isthereaspecificdate= this.datepipe.transform(response.aci_isthereaspecificdate, 'MM/dd/YYYY');
    }
   
    
    if (response.aci_immunizationtype) {
      let immunizationArray = response.aci_immunizationtype.split(',');
      immunizationArray.map((row: any) => {
        if (row == '805170000') {
          this.covid19 = true;
        }
        if (row == '805170001') {
          this.flu = true;
        }
        if (row == '805170003') {
          this.shingrix = true;
        }
        if (row == '805170004') {
          this.tdap = true;
        }
        if (row == '805170005') {
          this.pneumonia = true;
        }
        if (row == '805170006') {
          this.Hepatitis = true;
        }
      });
    }
    
    
    if (response.aci_clinicservicetype) {
      let serviceArray = response.aci_clinicservicetype.split(',');
      serviceArray.map((row: any) => {
        if (row == '805170000') {
          this.covid19testing = true;
        }
        if (row == '805170006') {
          this.travelhealth = true;
        }
        if (row == '805170005') {
         
          this.covid19testing = true;
        }
        if (row == '805170001') {
          this.a1ctesting = true;
        }
        if (row == '805170002') {
          this.cholestrol = true;
        }
        if (row == '805170003') {
          this.bloodglucose = true;
        }
        
      });
    }

  },
  error:(errorResponse)=>{
    console.log(errorResponse);
    
  }


})

  }
  onNextButtonFocus(){
    this.previuosButtonTabIndex = 0;
  }
  onPreviousButtonFocus(){
    this.previuosButtonTabIndex = -1;
  }
}
